export enum ProjectSettingEnum {
  UniqueCustomerNumber = 'UniqueCustomerNumber',
  AutoSetResponsible = 'AutoSetResponsible',
  DefaultVisibilityANAN = 'DefaultVisibilityANAN',
  DefaultVisibilityANAG = 'DefaultVisibilityANAG',
  DefaultVisibilityAGAN = 'DefaultVisibilityAGAN',
  DefaultVisibilityAGAG = 'DefaultVisibilityAGAG',
  CreateWebLink = 'CreateWebLink',
  MobileFaultEditAllowed = 'MobileFaultEditAllowed',
  IsAutoMobileCTNumberEnabled = 'IsAutoMobileCTNumberEnabled',
  IsExternalDistributorEnabled = 'IsExternalDistributorEnabled',
  UseProjectPlanPinConfiguration = 'UseProjectPlanPinConfiguration',
  IsPlanPinsEnabled = 'IsPlanPinsEnabled',
  SelectedPlanField = 'SelectedPlanField',
  PlanSource ='Plan source'
}
